import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'

// Platform pages
import PlatformLogin from './pages/platform/Login'
import PlatformDashboard from './pages/platform/Dashboard'
import PlatformTenants from './pages/platform/Tenants'
import PlatformCreateTenant from './pages/platform/CreateTenant'

// Tenant pages
import TenantHome from './pages/tenant/Home'
import TenantAdmin from './pages/tenant/Admin'
import TenantRegister from './pages/tenant/Register'
import TenantSettings from './pages/tenant/Settings'

// Marketing / Landing
import Landing from './pages/Landing'

// Context providers
import { AuthProvider } from './utils/auth'
import { ThemeProvider } from './components/ThemeContext'
import { ToastProvider } from './components/Toast'

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <Routes>
          {/* Platform admin routes */}
          <Route path="/platform" element={<PlatformLogin />} />
          <Route path="/platform/dashboard" element={<PlatformDashboard />} />
          <Route path="/platform/tenants" element={<PlatformTenants />} />
          <Route path="/platform/tenants/new" element={<PlatformCreateTenant />} />
          
          {/* Tenant routes (when accessed via subdomain or custom domain) */}
          <Route path="/" element={<TenantHome />} />
          <Route path="/register" element={<TenantRegister />} />
          <Route path="/camp/:campId" element={<TenantRegister />} />
          <Route path="/admin" element={<TenantAdmin />} />
          <Route path="/admin/settings" element={<TenantSettings />} />
          
          {/* Path-based tenant routes */}
          <Route path="/t/:slug" element={<TenantHome />} />
          <Route path="/t/:slug/register" element={<TenantRegister />} />
          <Route path="/t/:slug/camp/:campId" element={<TenantRegister />} />
          <Route path="/t/:slug/admin" element={<TenantAdmin />} />
          <Route path="/t/:slug/admin/settings" element={<TenantSettings />} />
          
          {/* Landing page for platform domain */}
          <Route path="/home" element={<Landing />} />
        </Routes>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
